import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { Ticket, TicketRecordType } from 'src/app/models/ticket/ticket.model';
import { getTicketType } from 'src/app/models/ticket/ticket.util';
import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../store';
import { SingleValueKPI } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

@Injectable()
export class OpenSuportCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter((s) => this.filterByStatusAndType(s)).length || 0;
      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: 'Open Support cases',
          title: 'All Open Support Tickets',
          value: dataValue,
          hyperlink: '/tickets',
          linkParams: {
            groupBy: 'Type',
            view: 'open',
            type: TicketRecordType.Support,
          },
          linkEnabled: true,
        } satisfies SingleValueKPI,
      };
    }),
  );

  private filterByStatusAndType(ticket: Ticket): boolean {
    return (
      getTicketType(ticket).includes(TicketRecordType.Support) &&
      !ticket.IsClosed
    );
  }
}
